import axios from "axios";

export const editUser = async (data, token) => {
  try {
    const formData = new FormData();

    formData.append("firstName", data.firstName);
    formData.append("lastName", data.lastName);
    formData.append("email", data.email);
    formData.append("profileImage", data.profile_img);
    formData.append("phone_number", data.phone_number);
    formData.append("user_id", data.user_id);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_USER}/editUser`,
      formData,
      {
        headers: {
          // "Content-Type" : "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response?.data?.message);
    }
    if (error.request) {
    }
    throw new Error(error.message);
  }
};
